import constants from "../../constants";
import { useContext, useState } from "react";
import AlertContext from "../../context/AlertContext";

import {
  generateBoilerPlateCCode,
  generateBoilerPlateJSCode,
  generateBoilerPlateCPPCode,
  generateBoilerPlateJavaCode,
  generateBoilerPlatePythonCode,
} from "../../util";

export default function CodingEditorHooks() {
  const Alert = useContext(AlertContext);

  let templateCodes = JSON.parse(
    JSON.stringify(
      Alert.codeDetails?.hasOwnProperty("templatecode")
        ? typeof Alert.codeDetails.templatecode !== "string"
          ? Alert.codeDetails.templatecode
          : JSON.parse(Alert.codeDetails.templatecode)
        : [],
    ),
  );

  const [editorLanguage, setEditorLanguage] = useState(
    Alert.status !== constants.QUESTION_STATUS.ASSIGNED &&
      (Alert.status !== constants.QUESTION_STATUS.RESUBMIT || Alert.status !== constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION)
      ? Alert.codeDetails?.langname?.toLowerCase() === "c" ||
        Alert.codeDetails?.langname?.toLowerCase() === "cpp"
        ? "java"
        : Alert.codeDetails?.langname?.toLowerCase()
      : Alert.codeDetails?.templatecode?.length > 0
      ? Alert.codeDetails.templatecode[0].langname?.toLowerCase() === "c" ||
        Alert.codeDetails.templatecode[0].langname?.toLowerCase() === "cpp"
        ? "java"
        : Alert.codeDetails.templatecode[0].langname?.toLowerCase()
      : "",
  );

  const customStyle = {
    control: (provided) => ({
      ...provided,
      border: "none",
      outline: "none",
      cursor: "pointer",
      minHeight: "24px",
      maxHeight: "24px",
      boxShadow: "none",
      alignContent: "center",
    }),
    option: (styles, { isDisabled, isFocused }) => {
      return {
        ...styles,
        color: "#344054",
        cursor: isDisabled ? "not-allowed" : "pointer",
        backgroundColor: isFocused ? "white" : "#F2F3F5",
      };
    },
  };

  const handleDisableLanguage = () => {
    if (
      Alert.isAdmin ||
      Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleBoilerPlateForNoteBook = (langId) => {
    if (langId === constants.LANG_ID.C) {
      return generateBoilerPlateCCode(
        "",
        [],
        [],
        [],
        {},
        Alert.testData.notebook,
      );
    } else if (langId === constants.LANG_ID.Cpp) {
      return generateBoilerPlateCPPCode(
        "",
        [],
        [],
        [],
        {},
        Alert.testData.notebook,
      );
    } else if (langId === constants.LANG_ID.Java) {
      return generateBoilerPlateJavaCode(
        "",
        [],
        [],
        [],
        {},
        Alert.testData.notebook,
      );
    } else if (langId === constants.LANG_ID.Javascript) {
      return generateBoilerPlateJSCode(
        "",
        [],
        [],
        [],
        {},
        Alert.testData.notebook,
      );
    } else if (langId === constants.LANG_ID.Python) {
      return generateBoilerPlatePythonCode(
        "",
        [],
        [],
        [],
        {},
        Alert.testData.notebook,
      );
    }
  };

  const handleChangeLanguage = (e) => {
    setEditorLanguage(
      e.label.toLowerCase() === "c" || e.label.toLowerCase() === "cpp"
        ? "java"
        : e.label.toLowerCase(),
    );
    console.log("templateCodes...........", templateCodes, "event", e);

    for (let i = 0; i < templateCodes.length; i++) {
      if (e.label.toLowerCase() === templateCodes[i].langname.toLowerCase()) {
        Alert.setSelectedLanguage(e);
        const template = templateCodes[i];
        console.log("template", template);

        let code;
        if (
          template.userCode === undefined &&
          template.usercode === undefined
        ) {
          code = Alert.testData?.notebook
            ? handleBoilerPlateForNoteBook(e.value)
            : (template.templateversion === 2
              ? template.executioncode
              : template.code);
        } else {
          code =
            template.usercode ??
            template.userCode ??
            (template.templateversion === 2
              ? template.executioncode
              : template.code);
        }
        console.log("code", code);

        Alert.setLearnerCode(code);
      }
    }

    let newCodeDetails = JSON.parse(JSON.stringify(Alert.codeDetails));

    newCodeDetails.templatecode = templateCodes;
    Alert.setCodeDetails(newCodeDetails);
  };

  const handleResetLearnerCode = () => {
    if (
      Alert.status === constants.QUESTION_STATUS.ASSIGNED ||
      Alert.status === constants.QUESTION_STATUS.CONTINUE ||
      (!Alert.isAdmin && (Alert.status === constants.QUESTION_STATUS.RESUBMIT || Alert.status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION))
    ) {
      for (let i = 0; i < templateCodes.length; i++) {
        if (
          Alert.selectedLanguage.label.toLowerCase() ===
          templateCodes[i].langname.toLowerCase()
        ) {
          templateCodes[i].userCode = Alert.testData.notebook
            ? handleBoilerPlateForNoteBook(templateCodes[i].langid)
            : templateCodes[i].templateversion === 2
            ? templateCodes[i].executioncode
            : templateCodes[i].code;

          Alert.setLearnerCode(templateCodes[i].userCode);
        }
      }
    } else {
      Alert.setLearnerCode(Alert.codeDetails.answer);
    }

    let newCodeDetails = JSON.parse(JSON.stringify(Alert.codeDetails));

    newCodeDetails.templatecode = templateCodes;
    Alert.setCodeDetails(newCodeDetails);
  };

  const handleLearnerCode = (value) => {
    if (
      Alert.status === constants.QUESTION_STATUS.ASSIGNED ||
      Alert.status === constants.QUESTION_STATUS.RESUBMIT ||
      Alert.status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION ||
      Alert.status === constants.QUESTION_STATUS.CONTINUE
    ) {
      for (let i = 0; i < templateCodes.length; i++) {
        if (
          Alert.selectedLanguage.label.toLowerCase() ===
          templateCodes[i].langname.toLowerCase()
        ) {
          templateCodes[i].userCode = value;
          templateCodes[i].usercode = value;
          Alert.setLearnerCode(value);
        }
      }
    } else {
      Alert.setLearnerCode(value);
    }

    let newCodeDetails = JSON.parse(JSON.stringify(Alert.codeDetails));

    newCodeDetails.isChangeCode = true;
    newCodeDetails.templatecode = templateCodes;
    Alert.setCodeDetails(newCodeDetails);
  };

  return {
    customStyle,
    editorLanguage,
    handleLearnerCode,
    setEditorLanguage,
    handleChangeLanguage,
    handleDisableLanguage,
    handleResetLearnerCode,
    handleBoilerPlateForNoteBook,
  };
}
